import type { AnyAction } from 'redux';

import { baseReducer } from '../../core/base-reducer';
import * as Actions from '../ltl.actions';
import type { WizardOpenConfig } from '../ltl.types';

type LtlCoreState = {
  isWizardOpen: boolean;
  wizardOpenConfig: WizardOpenConfig | null;
  isCancellingShipment: boolean;
  isDownloadingDocument: boolean;
};

const initialState: LtlCoreState = {
  isWizardOpen: false,
  wizardOpenConfig: null,
  isCancellingShipment: false,
  isDownloadingDocument: false,
};

const actionHandlerMap: Record<string, (state: LtlCoreState, action: AnyAction) => LtlCoreState> = {
  [Actions.LTL_OPEN_WIZARD]: (state, action) => ({
    ...state,
    isWizardOpen: true,
    wizardOpenConfig: action.config ?? { mode: 'new-quote' },
  }),
  [Actions.LTL_CLOSE_WIZARD]: (state) => ({
    ...state,
    isWizardOpen: false,
    wizardOpenConfig: null,
  }),

  [Actions.LTL_CANCEL_SHIPMENT_REQUEST]: (state) => ({
    ...state,
    isCancellingShipment: true,
  }),
  [Actions.LTL_CANCEL_SHIPMENT_SUCCESS]: (state) => ({
    ...state,
    isCancellingShipment: false,
  }),
  [Actions.LTL_CANCEL_SHIPMENT_ERROR]: (state) => ({
    ...state,
    isCancellingShipment: false,
  }),

  [Actions.LTL_DOWNLOAD_DOCUMENT_REQUEST]: (state) => ({
    ...state,
    isDownloadingDocument: true,
  }),
  [Actions.LTL_DOWNLOAD_DOCUMENT_SUCCESS]: (state) => ({
    ...state,
    isDownloadingDocument: false,
  }),
  [Actions.LTL_DOWNLOAD_DOCUMENT_ERROR]: (state) => ({
    ...state,
    isDownloadingDocument: false,
  }),
};

export const ConnectedActionHandlerMap = baseReducer(initialState, actionHandlerMap);
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { namespace } from './ltl.core.reducer.metadata';
